import React, { useState, useEffect } from 'react';
import { Row, Col, Card, CardBody, Collapse } from 'reactstrap';
import { Form } from '@availity/form';
import { Input, Switch, Select } from '../../lib/form-field';
import formValidation from './formValidation';

import * as usersActions from '../../store/users/actions';
import * as affiliatesActions from '../../store/affiliates/actions';
import { userEmailInUse } from '../../selectors/user';
import { useDispatch, useSelector } from 'react-redux';
import { SubmitButton } from '../Common/Modal/modalActionButtons';
import roles from '../../config/roles';

const FormUser = ({ loading, user, create, closeModal }) => {
  const editingUser = user || {};

  const [active, setActive] = useState(editingUser.active || false);

  const emailsInUse = useSelector(userEmailInUse(editingUser.id));
  const affiliates = useSelector((state) => state.Affiliate.affiliates);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(affiliatesActions.syncAffiliates());
  }, []);

  const handleSubmit = (values) => {
    dispatch(
      create
        ? usersActions.createUser(values)
        : usersActions.updateUser({
            id: editingUser.id,
            ...values,
            active,
          }),
    );
    closeModal();
  };

  return (
    <Card>
      <CardBody>
        <Form
          initialValues={{ ...editingUser }}
          validationSchema={formValidation(emailsInUse)}
          onSubmit={handleSubmit}>
          {({ isValid, values }) => (
            <>
              <Row>
                <Col md="3">
                  <Input
                    type="text"
                    name="firstName"
                    id="firstName"
                    label="First Name"
                  />
                </Col>
                <Col md="3">
                  <Input
                    type="text"
                    name="lastName"
                    id="lastName"
                    label="Last Name"
                  />
                </Col>
                <Col md="3">
                  <Input
                    type="text"
                    name="displayName"
                    id="displayName"
                    label="Display Name"
                  />
                </Col>
                <Col md="3">
                  <Input type="text" name="email" id="email" />
                </Col>
              </Row>
              <Row>
                <Col md="3">
                  <Switch
                    name="active"
                    label="Active?"
                    defaultChecked={active}
                    onClick={() => setActive(!active)}
                  />
                </Col>
                <Col md="3">
                  <Collapse isOpen={values.role === roles.AFFILIATE}>
                    <Select
                      name="affiliateId"
                      id="affiliateId"
                      label="Affiliate"
                      options={affiliates.map(({ id, name }) => ({
                        label: name,
                        value: id,
                      }))}
                    />
                  </Collapse>
                </Col>
              </Row>
              <div className="modal-footer">
                <SubmitButton disabled={!isValid || loading} create={create} />
              </div>
            </>
          )}
        </Form>
      </CardBody>
    </Card>
  );
};

export default FormUser;
